import React, { useState, useEffect } from 'react';
import AdminNav from './AdminNav';
import './AdminLayout.css';

import { API, authHeadersOnly } from '../services/apiConfig';

const BASE = API;

function ManageSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchSubscribers(); }, []);

  const fetchSubscribers = async () => {
    try {
      const res = await fetch(`${BASE}/api/subscribers`, { headers: authHeadersOnly() });
      const data = res.ok ? await res.json() : [];
      setSubscribers(data);
    } catch { setSubscribers([]); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this subscriber?')) return;
    await fetch(`${BASE}/api/subscribers/${id}`, { method: 'DELETE', headers: authHeadersOnly() });
    setSubscribers(prev => prev.filter(s => s.id !== id));
  };

  const handleLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); window.location.href = '/login'; };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="admin-page-wrapper">
        <div className="admin-page-container">
          <div className="admin-page-header">
            <h1 className="admin-page-title">Newsletter Subscribers</h1>
            <p className="admin-page-subtitle">{subscribers.length} subscriber{subscribers.length !== 1 ? 's' : ''} signed up for updates</p>
          </div>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '60px', color: '#888' }}>Loading...</p>
          ) : subscribers.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '60px', color: '#888' }}>No subscribers yet.</p>
          ) : (
            <div style={{ background: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
                    <th style={{ padding: '14px 20px', textAlign: 'left', fontWeight: '700', color: '#555' }}>#</th>
                    <th style={{ padding: '14px 20px', textAlign: 'left', fontWeight: '700', color: '#555' }}>Email</th>
                    <th style={{ padding: '14px 20px', textAlign: 'left', fontWeight: '700', color: '#555' }}>Subscribed At</th>
                    <th style={{ padding: '14px 20px', textAlign: 'center', fontWeight: '700', color: '#555' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {subscribers.map((s, idx) => (
                    <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0', transition: 'background 0.15s' }}
                      onMouseOver={e => e.currentTarget.style.background = '#fafafa'}
                      onMouseOut={e => e.currentTarget.style.background = 'white'}>
                      <td style={{ padding: '12px 20px', color: '#999' }}>{idx + 1}</td>
                      <td style={{ padding: '12px 20px', fontWeight: '500', color: '#1a1a1a' }}>{s.email}</td>
                      <td style={{ padding: '12px 20px', color: '#666' }}>
                        {s.subscribedAt ? new Date(s.subscribedAt + 'Z').toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Kolkata' }) : '—'}
                      </td>
                      <td style={{ padding: '12px 20px', textAlign: 'center' }}>
                        <button onClick={() => handleDelete(s.id)}
                          style={{ background: '#fff0f0', color: '#cc0000', border: '1px solid #ffcccc', borderRadius: '8px', padding: '5px 14px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', transition: 'all 0.15s' }}
                          onMouseOver={e => { e.currentTarget.style.background = '#cc0000'; e.currentTarget.style.color = 'white'; }}
                          onMouseOut={e => { e.currentTarget.style.background = '#fff0f0'; e.currentTarget.style.color = '#cc0000'; }}>
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ManageSubscribers;
